/* Shon Shon theme scripts. No dependencies. */
(function () {
  'use strict';
  var S = window.ShonShon || { routes: {}, strings: {} };
  var root = (S.routes.root || '/').replace(/\/?$/, '/');

  function money(cents) {
    var fmt = S.moneyFormat || '₪{{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    var noDec = Math.round(cents / 100).toString();
    return fmt.replace(/\{\{\s*amount_no_decimals[^}]*\}\}/, noDec).replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  function toast(text) {
    var el = document.createElement('div');
    el.className = 'toast';
    el.setAttribute('role', 'status');
    el.textContent = text + ' ';
    var a = document.createElement('a');
    a.href = S.routes.cart || '/cart';
    a.textContent = '→';
    a.setAttribute('aria-label', 'cart');
    el.appendChild(a);
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 3500);
  }

  function updateCartCount() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      }).catch(function () {});
  }

  function addItems(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || 'Error'); });
      return r.json();
    }).then(function (res) { updateCartCount(); return res; });
  }

  /* Mobile menu */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-menu-toggle]');
    if (t) {
      var header = t.closest('.site-header');
      var open = header.classList.toggle('is-open');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  });
  /* Close mega menus when clicking outside */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.nav details[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  /* Language selector auto-submit */
  document.querySelectorAll('[data-lang-select]').forEach(function (sel) {
    sel.addEventListener('change', function () { sel.form.submit(); });
  });

  /* Collection: sort select auto-submit */
  document.querySelectorAll('[data-autosubmit]').forEach(function (el) {
    el.addEventListener('change', function () { el.form.submit(); });
  });

  /* Quantity buttons */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    v = b.getAttribute('data-qty') === '+' ? v + 1 : Math.max(parseInt(input.min || '0', 10), v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Product form (product page + quick view) */
  function initProductForm(form) {
    var dataEl = form.querySelector('script[type="application/json"][data-product]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var addBtn = form.querySelector('[data-add]');
    var buyRow = form.querySelector('[data-buy-row]');
    var notifyBox = form.parentElement.querySelector('[data-notify-box]');
    var priceEl = form.closest('[data-product-root]') ? form.closest('[data-product-root]').querySelector('[data-price]') : null;
    var needsChoice = form.hasAttribute('data-require-choice');
    var chosen = !needsChoice;

    function selectedOptions() {
      return product.options.map(function (_, i) {
        var checked = form.querySelector('input[data-option-index="' + i + '"]:checked');
        return checked ? checked.value : null;
      });
    }
    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === null || o === opts[i]; });
      });
    }
    function markAvailability(opts) {
      form.querySelectorAll('input[data-option-index]').forEach(function (input) {
        var i = parseInt(input.getAttribute('data-option-index'), 10);
        var test = opts.slice(); test[i] = input.value;
        var v = product.variants.find(function (vv) { return vv.options.every(function (o, j) { return test[j] === null || o === test[j]; }); });
        var label = form.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.toggle('is-unavailable', !v || !v.available);
      });
    }
    function render() {
      var opts = selectedOptions();
      markAvailability(opts);
      var complete = opts.every(function (o) { return o !== null; });
      var v = complete ? findVariant(opts) : null;
      if (v) {
        idInput.value = v.id;
        if (priceEl) {
          priceEl.innerHTML = (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s> ' : '') + '<span class="price__now">' + money(v.price) + '</span>';
          priceEl.classList.toggle('price--sale', v.compare_at_price > v.price);
        }
        if (form.closest('[data-product-page]') && window.history.replaceState) {
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString());
        }
      }
      var ready = chosen && v && v.available;
      var soldOut = chosen && v && !v.available;
      if (addBtn) {
        addBtn.disabled = !ready;
        addBtn.textContent = ready ? S.strings.add : (soldOut ? S.strings.soldOut : S.strings.choose);
      }
      if (notifyBox) {
        notifyBox.hidden = !soldOut;
        var vf = notifyBox.querySelector('[data-notify-variant]');
        if (vf && v) vf.value = product.title + ' – ' + v.title;
      }
      if (buyRow) buyRow.hidden = !!soldOut;
      form.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v }, bubbles: true }));
    }
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[data-option-index]')) { chosen = true; render(); }
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var qty = form.querySelector('input[name="quantity"]');
      var props = {};
      form.querySelectorAll('[name^="properties["]').forEach(function (p) {
        if ((p.type === 'checkbox' && !p.checked) || !p.value) return;
        props[p.name.slice(11, -1)] = p.value;
      });
      /* Gift card: send to recipient only when an email was entered */
      if ('__shopify_send_gift_card_to_recipient' in props && !props['Recipient email']) {
        ['__shopify_send_gift_card_to_recipient', 'Recipient name', 'Send on'].forEach(function (k) { delete props[k]; });
        if (props['_from'] && props.Message) props.Message = props.Message + ' — ' + props['_from'];
      }
      if (props['Send on'] && !/^\d{4}-\d{2}-\d{2}$/.test(props['Send on'])) delete props['Send on'];
      addBtn.disabled = true;
      addItems([{ id: parseInt(idInput.value, 10), quantity: qty ? parseInt(qty.value, 10) || 1 : 1, properties: props }])
        .then(function () {
          addBtn.textContent = S.strings.added;
          toast(S.strings.added);
          setTimeout(render, 1600);
          var dialog = form.closest('dialog'); if (dialog) dialog.close();
        })
        .catch(function (err) { addBtn.disabled = false; toast(err.message); });
    });
    render();
  }
  document.querySelectorAll('form[data-product-form]').forEach(initProductForm);

  /* Product gallery thumbs */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-thumb]');
    if (!t) return;
    var gallery = t.closest('[data-gallery]');
    var main = gallery.querySelector('[data-main-image]');
    main.src = t.getAttribute('data-src');
    main.srcset = t.getAttribute('data-srcset') || '';
    main.alt = t.getAttribute('data-alt') || '';
    gallery.querySelectorAll('[data-thumb]').forEach(function (b) { b.setAttribute('aria-current', b === t ? 'true' : 'false'); });
  });
  /* Switch main image when variant has its own image */
  document.addEventListener('variant:change', function (e) {
    var v = e.detail.variant;
    if (!v || !v.featured_media) return;
    var root = e.target.closest('[data-product-root]');
    var thumb = root && root.querySelector('[data-thumb][data-media-id="' + v.featured_media.id + '"]');
    if (thumb) thumb.click();
  });

  /* Quick view */
  var qv = document.getElementById('QuickView');
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-view]');
    if (!b || !qv) return;
    e.preventDefault();
    var url = b.getAttribute('data-quick-view');
    var body = qv.querySelector('[data-qv-body]');
    body.innerHTML = '<p style="padding:40px">…</p>';
    if (typeof qv.showModal === 'function') qv.showModal();
    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=quick-view-content')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('[data-qv-content]');
        body.innerHTML = content ? content.innerHTML : '';
        var form = body.querySelector('form[data-product-form]');
        if (form) initProductForm(form);
      }).catch(function () { window.location.href = url; });
  });
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-close-dialog]');
    if (c) c.closest('dialog').close();
  });
  document.querySelectorAll('dialog').forEach(function (d) {
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
  });

  /* Notify-me modal (from collection cards) */
  var nm = document.getElementById('NotifyModal');
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-notify]');
    if (!b || !nm) return;
    e.preventDefault();
    nm.querySelector('[data-notify-name]').textContent = b.getAttribute('data-notify');
    nm.querySelector('[data-notify-variant]').value = b.getAttribute('data-notify');
    if (typeof nm.showModal === 'function') nm.showModal();
  });

  /* Single-variant quick add from product cards */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    btn.disabled = true;
    addItems([{ id: parseInt(form.querySelector('input[name="id"]').value, 10), quantity: 1 }])
      .then(function () { btn.textContent = S.strings.added; toast(S.strings.added); setTimeout(function () { btn.disabled = false; btn.textContent = S.strings.add; }, 1800); })
      .catch(function (err) { btn.disabled = false; toast(err.message); });
  });

  /* Shop the look: add all */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add-look]');
    if (!b) return;
    var ids = JSON.parse(b.getAttribute('data-add-look') || '[]').filter(Boolean);
    if (!ids.length) return;
    b.disabled = true;
    addItems(ids.map(function (id) { return { id: id, quantity: 1 }; }))
      .then(function () { b.textContent = S.strings.added; toast(S.strings.added); })
      .catch(function (err) { b.disabled = false; toast(err.message); });
  });

  /* Cart: gift toggle shows/hides gift fields */
  document.querySelectorAll('[data-gift-toggle]').forEach(function (cb) {
    var box = document.querySelector('[data-gift-fields]');
    function sync() { if (box) box.hidden = !cb.checked; }
    cb.addEventListener('change', sync); sync();
  });
  /* Cart: qty change auto-submit */
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    var timer;
    input.addEventListener('change', function () { clearTimeout(timer); timer = setTimeout(function () { input.form.submit(); }, 500); });
  });

  /* Character counters */
  document.querySelectorAll('[data-count-for]').forEach(function (out) {
    var input = document.getElementById(out.getAttribute('data-count-for'));
    if (!input) return;
    function sync() { out.textContent = input.value.length + '/' + (input.maxLength > 0 ? input.maxLength : ''); }
    input.addEventListener('input', sync); sync();
  });

  /* Gift card live preview */
  document.querySelectorAll('[data-gc-form]').forEach(function (form) {
    var rootEl = form.closest('[data-product-root]');
    function text(sel, val) { var el = rootEl.querySelector(sel); if (el) el.textContent = val; }
    form.addEventListener('input', function () {
      var to = form.querySelector('[data-gc-to]'); var from = form.querySelector('[data-gc-from]'); var msg = form.querySelector('[data-gc-msg]');
      if (to) text('[data-gc-to-preview]', to.value ? to.value : rootEl.getAttribute('data-gc-to-default'));
      if (from) text('[data-gc-from-preview]', from.value ? from.value : rootEl.getAttribute('data-gc-from-default'));
      if (msg) text('[data-gc-msg-preview]', msg.value || rootEl.getAttribute('data-gc-msg-default'));
    });
    form.addEventListener('variant:change', function (e) {
      if (e.detail.variant) text('[data-gc-amount]', money(e.detail.variant.price));
    });
  });

  /* Hero video sound toggle */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hero-sound]');
    if (!b) return;
    var v = b.parentElement.querySelector('video');
    if (!v) return;
    v.muted = !v.muted;
    if (!v.muted) v.play();
    b.textContent = v.muted ? '🔇' : '🔊';
    b.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
  });

  /* Copy buttons */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copy]');
    if (!b) return;
    var val = b.getAttribute('data-copy');
    var done = function () { var t = b.textContent; b.textContent = b.getAttribute('data-copied') || '✓'; setTimeout(function () { b.textContent = t; }, 1500); };
    if (navigator.clipboard) navigator.clipboard.writeText(val).then(done).catch(function () {});
  });
})();
